import toolsCatalogData from "./toolsCatalog.json";

export interface ToolRelatedLink {
  title: string;
  url: string;
}

export interface ToolCatalogItem {
  title: string;
  slug: string;
  url: string;
  category: string;
  description: string;
  primaryKeyword: string;
  secondaryKeywords: string[];
  searchIntent: string;
  seoTitle: string;
  metaDescription: string;
  relatedTools: string[];
  relatedBlogs: ToolRelatedLink[];
  relatedServices: ToolRelatedLink[];
  priority: string;
  schemaType: "WebApplication";
}

export const toolsCatalog = toolsCatalogData as ToolCatalogItem[];

export function getToolBySlug(slug?: string) {
  return toolsCatalog.find((tool) => tool.slug === slug);
}

export function getToolsBySlugs(slugs: string[]) {
  return slugs
    .map((slug) => getToolBySlug(slug))
    .filter((tool): tool is ToolCatalogItem => Boolean(tool));
}

export function getToolCategories() {
  return Array.from(new Set(toolsCatalog.map((tool) => tool.category)));
}

export function getToolsByCategory(category: string) {
  return toolsCatalog.filter((tool) => tool.category === category);
}
